import { Component, Input, ViewChild } from '@angular/core';
import { Layout } from 'modules/layout';
import { InputType } from 'enums/InputType';
import { ValidationType } from 'enums/validationType';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Inputs } from 'modules/inputs';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { DomainService, DomainWithDnsInformation } from 'services/domain.service';
import { SetDomainEmailsRequestModel } from 'models/generated/Distribution.Api.Models.SetDomainEmailsRequest';
import { ButtonComponent } from 'components/input/button/button.component';

@Component({
	selector: 'change-domain-email',
	templateUrl: './change-domain-email.component.html',
	providers: [FormValidationService],
	imports: [Layout, Inputs, TranslatePipe]
})
export class ChangeDomainEmailComponent {

	@ViewChild('setDomainEmailButton') setDomainEmailButton!: ButtonComponent;

	private _domain!: DomainWithDnsInformation;
	validationType = ValidationType;
	inputTypeEnum = InputType;
	requestModel = new SetDomainEmailsRequestModel();

	@Input() set domain(value: DomainWithDnsInformation) {
		this._domain = value;
		this.requestModel.domainName = value.name
	}
	get domain() { return this._domain; }

	constructor(private readonly navigation: NavigationService, private readonly domainService: DomainService) { }

	setDomainEmail() {
		this.domainService.setDomainEmails(this.requestModel).then(_ => {
			this.setDomainEmailButton.succeeded();
		});
	}

	close() {
		this.navigation.closeView(this);
	}
}
